import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/project/front-org/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/project/front-org/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/project/front-org/src/app/[locale]/sections/view/[view_id]/View.tsx");
